<template>
  <modal
    name="edit-inventory-modal"
    width="600"
    height="auto"
    :adaptive="true"
    :scrollable="true"
  >
    <div class="p-6">
      <h2 class="text-xl font-bold mb-4">Envanter Düzenle</h2>

      <form v-if="form" @submit.prevent="save">
        <div class="grid grid-cols-1 gap-4">

          <!-- Ürün Kodu (Salt Okunur) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Ürün Kodu
            </label>
            <input
              :value="form.product_code"
              type="text"
              disabled
              class="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg cursor-not-allowed"
            />
          </div>

          <!-- Ürün Adı -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Ürün Adı <span class="text-red-500">*</span>
            </label>
            <input
              v-model="form.name"
              type="text"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <!-- Kategori -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Kategori <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.category"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="POMPA&HORTUM&DUSURUCU">Pompa & Hortum & Düşürücü</option>
              <option value="GUVENLIK">Güvenlik Ekipmanı</option>
              <option value="YEDEK_PARCA">Yedek Parça</option>
              <option value="DIGER">Diğer</option>
            </select>
          </div>

          <!-- Seri Numarası -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Seri Numarası
            </label>
            <input
              v-model="form.serial_number"
              type="text"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <!-- Durum -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Durum
            </label>
            <select
              v-model="form.status"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="AKTIF">Aktif</option>
              <option value="PASIF">Pasif</option>
              <option value="BAKIM">Bakımda</option>
              <option value="ARIZALI">Arızalı</option>
            </select>
          </div>

          <!-- Açıklama -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Açıklama
            </label>
            <textarea
              v-model="form.description"
              rows="3"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            ></textarea>
          </div>

        </div>

        <!-- Butonlar -->
        <div class="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            @click="$modal.hide('edit-inventory-modal')"
            class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            İptal
          </button>
          <button
            type="submit"
            :disabled="loading"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-blue-400"
          >
            <span v-if="loading">Güncelleniyor...</span>
            <span v-else>Güncelle</span>
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import { inventory } from '../../../../networking/urlmanager';

export default {
  name: 'EditInventoryModal',
  props: {
    inventory: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      form: null
    };
  },
  watch: {
    inventory: {
      handler(newVal) {
        if (newVal) {
          this.form = {
            id: newVal.id,
            product_code: newVal.product_code,
            name: newVal.name,
            category: newVal.category,
            serial_number: newVal.serial_number || '',
            quantity: newVal.quantity || 1,
            unit: newVal.unit || 'ADET',
            description: newVal.description || '',
            status: newVal.status || 'AKTIF'
          };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async save() {
      if (!this.form.name || !this.form.category) {
        this.$toast.error('Lütfen zorunlu alanları doldurun');
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post(inventory.edit, this.form, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.$toast.success('Envanter başarıyla güncellendi');
          this.$modal.hide('edit-inventory-modal');
          this.$emit('refresh');
        }
      } catch (error) {
        console.error('Error updating inventory:', error);
        this.$toast.error(error.response?.data?.message || 'Envanter güncellenirken hata oluştu');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>